<template>
  <!-- width="600px" 或者  width="60%"   -->
  <el-dialog
    :close-on-click-modal="false"
    title="延期丢失"
    :show-close="true"
    :visible="true"
    :before-close="handleBeforeClose"
    width="360px"
  >
    <div class="dialog__container">
      <el-form
        inline
        ref="form"
        class="search-form"
        label-position="right"
        :model="form"
        :rules="rules"
        label-width="70px"
      >
        <el-form-item label="最近丢失：">
          <el-input
            size="mini"
            v-model.trim="extensionTime"
            disabled
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="延期丢失：" class="mb0" prop="extensionTime">
          <el-date-picker
            v-model="form.extensionTime"
            align="right"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="选择日期"
            size="mini"
            prefix-icon=" "
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button
        class="plr28"
        size="mini"
        type="info"
        plain
        @click="handleCancel"
        >取消</el-button
      >
      <el-button
        class="plr28"
        type="primary"
        size="mini"
        :loading="loadBtn"
        @click="handleConfirm"
        >确定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { extensionContract } from "@/api/ContractManagement";
export default {
  data() {
    return {
      form: {
        extensionTime: ""
      },
      rules: {
        extensionTime: [
          {
            required: true,
            message: "请选择延期丢失时间",
            trigger: "change",
          },
        ],
      },
      loadBtn: false
    };
  },
  props: {
    extensionTime: {
      required: true
    },
    contractId: {
      required: true
    }
  },
  created() {
    this.pickerOptions = {
      disabledDate: time => {
        if (this.extensionTime) {
          const extensionTime = new Date(this.extensionTime).getTime()
          return time.getTime() < extensionTime
        } else {
          return false
        }
      }
    }
  },
  methods: {
    handleBeforeClose(done) {
      this.$emit("cancel");
      done();
    },
    handleCancel() {
      this.$emit("cancel");
    },
    async handleConfirm() {
      if (this.loadBtn) return;
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          this.loadBtn = true;
          let params = {
            contractId: this.contractId,
            extensionTime: this.form.extensionTime
          }
          const res = await extensionContract(params);
          if (res.code === 200) {
            this.$message.success("成功");
            this.$emit("confirm");
          }
          this.loadBtn = false;
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/ContractManagement/components/ExtensionContract.vue